<lex-action-panel>
  <div action-title>Extract or Remove Pages</div>
  <div action-body>
    <div style="display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                align-content:flex-start;
                justify-content: center;
                padding: 16px;
                gap: 16px;">
                <lex-text-input label="Pages" placeholder="Example: 10,20,24-32,12-31" [formControl]="splitStringControl" (keypress)="splitDocInstructionsKeyPress($event)"></lex-text-input>
                <mat-error *ngIf="splitStringControl.invalid && !splitStringControl.pristine">
                  <ng-container *ngIf="splitStringControl.errors.required">
                      Split instructions must not be empty.
                  </ng-container>
                  <ng-container *ngIf="splitStringControl.errors.maxlength">
                    Split instructions must be at most 2048 characters long.
                  </ng-container>
              </mat-error>
      <lex-flat-button (click)="splitDoc('split')" [disabled]="splitStringControl.invalid"
        [icon]="'fa-duotone fa-check-double'" [label]="'Extract Pages'" style="width:100%;" matTooltip="Action: Each range in the instructions will create a new document containing the
        specified pages. The original document will not be changed. Example: 10,20,24-32,12-31">
      </lex-flat-button>
      <lex-flat-button (click)="splitDoc('remove')" [disabled]="splitStringControl.invalid"
        [icon]="'fa-duotone fa-check-double'" [label]="'Remove Pages'" style="width:100%;" matTooltip="Action: A new document will be created with the specified ranges removed. The
      original document will not be changed. Example: 10,20,24-32,12-31">
      </lex-flat-button>
    </div>
  </div>
</lex-action-panel>
